var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner tab-file-history" },
    [
      _c(
        "div",
        { staticStyle: { padding: "5px 0 10px 0" } },
        [
          _c(
            "el-button",
            {
              attrs: { no: "1", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.toQuery(1)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("FileHistory.Refresh")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "2", type: "primary", disabled: _vm.canUse },
              on: {
                click: function($event) {
                  _vm.cloudFile.visible = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "3", type: "danger", disabled: _vm.canUse },
              on: { click: _vm.remove }
            },
            [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "4", type: "primary", disabled: _vm.canUse },
              on: { click: _vm.download }
            },
            [_vm._v(_vm._s(_vm.$t("FileHistory.BatchDownload")))]
          ),
          _vm.ingotUploadButton
            ? _c(
                "el-button",
                { attrs: { no: "5", type: "primary", disabled: _vm.canUse } },
                [_vm._v(_vm._s(_vm.$t("FileHistory.ingotUpload")))]
              )
            : _vm._e(),
          _vm.ingotButton
            ? _c(
                "el-button",
                { attrs: { no: "6", type: "primary", disabled: _vm.canUse } },
                [_vm._v(_vm._s(_vm.$t("FileHistory.ingotLog")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { style: "flex-grow:1;height: " + _vm.gridHeight + ";" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": "190811",
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob,
          "is-sirui": _vm.cloudFile.isSirui,
          "other-param": this.otherParam,
          "file-history-jc": this.fileHistoryJc
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: function(data) {
            _vm.updateSop(data)
          }
        }
      }),
      _vm.isShowingDetailForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.isShowingDetailForm,
                title: _vm.showDetailTitle,
                "append-to-body": "",
                width: "400px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isShowingDetailForm = $event
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "300px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptionsFileDetail,
                  "column-defs": _vm.columnDefsFileDetail,
                  "row-data": _vm.rowDataFileDetail
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.gridApiFileDetail = params.api)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("pre-view-file-dialog", {
        attrs: {
          "v-if": _vm.previewFileData.visible,
          no: "preview",
          title: _vm.$t("FileHistory.preview"),
          visible: _vm.previewFileData.visible,
          file: _vm.previewFileData.file,
          "can-maximize": true
        },
        on: { close: _vm.closePreviewDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }